'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthId$() {
  this.cc8 = null;
  this.cc9 = false;
  this.cc6 = null;
  this.cc7 = false;
}
export { $c_Lpresto_types$TwoFactorAuthId$ as $c_Lpresto_types$TwoFactorAuthId$ };
$p = $c_Lpresto_types$TwoFactorAuthId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthId$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthId$() {
}
export { $h_Lpresto_types$TwoFactorAuthId$ as $h_Lpresto_types$TwoFactorAuthId$ };
$h_Lpresto_types$TwoFactorAuthId$.prototype = $p;
$p.va = (function() {
  if ((!this.cc9)) {
    this.cc8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.cc9 = true;
  }
  return this.cc8;
});
$p.zb = (function() {
  if ((!this.cc7)) {
    this.cc6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.cc7 = true;
  }
  return this.cc6;
});
var $d_Lpresto_types$TwoFactorAuthId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthId$, "presto.types$TwoFactorAuthId$", ({
  a2f: 1,
  D: 1
}));
export { $d_Lpresto_types$TwoFactorAuthId$ as $d_Lpresto_types$TwoFactorAuthId$ };
var $n_Lpresto_types$TwoFactorAuthId$;
function $m_Lpresto_types$TwoFactorAuthId$() {
  if ((!$n_Lpresto_types$TwoFactorAuthId$)) {
    $n_Lpresto_types$TwoFactorAuthId$ = new $c_Lpresto_types$TwoFactorAuthId$();
  }
  return $n_Lpresto_types$TwoFactorAuthId$;
}
export { $m_Lpresto_types$TwoFactorAuthId$ as $m_Lpresto_types$TwoFactorAuthId$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Id$.js.map
